module.exports = __webpack_public_path__ + "img/logo.22726055.svg";